import {LazyLoader} from "./LazyLoader";

document.addEventListener( 'DOMContentLoaded',  () => {

    // Initializing lazyloading
    const lazyloading = new LazyLoader ({
        thumbs: `#photo-thumbs`,
        paging: `.lazyloading-paging`,
        button: document.querySelector(`#load-thumbs`)
    });

});